import { Shield, Bus, Euro } from "lucide-react";

export function Services() {
  const services = [
    {
      icon: Shield,
      title: "Parking Sécurisé & Privé",
      description: "Espace privé avec places de parking et box individuels",
    },
    {
      icon: Bus,
      title: "Navette Gratuite",
      description: "Transport vers l'aéroport à toute heure",
    },
    {
      icon: Euro,
      title: "Meilleurs Tarifs",
      description: "Prix attractifs",
    },
  ];

  return (
    <section id="services" className="py-20 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-center text-white mb-16">
          Nos Services
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="p-8 border-2 border-[#FF7954] rounded-xl text-center
                         transform hover:-translate-y-2 transition-all duration-300
                         hover:border-[#FCDEBE] hover:shadow-xl bg-[#0A0A0A]"
            >
              <div className="flex justify-center mb-6">
                <service.icon size={48} className="text-white" />
              </div>
              <h3 className="text-2xl font-semibold text-white mb-4">
                {service.title}
              </h3>
              <p className="text-[#FCDEBE]">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
